import { render, staticRenderFns } from "./idea.vue?vue&type=template&id=53710248&scoped=true&"
import script from "./idea.vue?vue&type=script&lang=js&"
export * from "./idea.vue?vue&type=script&lang=js&"
import style0 from "./idea.vue?vue&type=style&index=0&id=53710248&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53710248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53710248')) {
      api.createRecord('53710248', component.options)
    } else {
      api.reload('53710248', component.options)
    }
    module.hot.accept("./idea.vue?vue&type=template&id=53710248&scoped=true&", function () {
      api.rerender('53710248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/lingyue-tech/index/component/idea/idea.vue"
export default component.exports